/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function cartRecommended(pro_id){
  console.log(pro_id);
    var productRecommendationsSection = document.querySelector('#backdrop');

fetch(window.Shopify.routes.root + 'recommendations/products?product_id='+pro_id+'&limit=3&section_id=cart-related-product&intent=related')
 .then(response => response.text())
 .then((text) => {
    var html = document.createElement('div');
    html.innerHTML = text;
    var recommendations = html.querySelector('#backdrop');
    console.log(recommendations);
    if (recommendations && recommendations.innerHTML.trim().length) {
      productRecommendationsSection.innerHTML = recommendations.innerHTML;
    }
 });
}
// image stack on load start
$(document).ready(function () {
    $('.custom_media_stack .Carousel__Cell:lt(6)').show();
    $('.less').hide();
    var items =  $('.custom_media_stack .Carousel__Cell').length;    
    var shown =  6;
    $(document).on('click', '.more', function () {
        $('.less').show();
        shown = $('.custom_media_stack .Carousel__Cell:visible').length+6;
        if(shown< items) {
          $('.custom_media_stack .Carousel__Cell:lt('+shown+')').show(300);
        } else {
          $('.custom_media_stack .Carousel__Cell:lt('+items+')').show(300);
          $('.more').hide();
        }
    });
    $(document).on('click', '.less', function () {
        $('.custom_media_stack .Carousel__Cell').not(':lt(6)').hide(300);
        $('.more').show();
        $('.less').hide();
    });
$('#tabs-nav .tab_head:first-child').addClass('tab_active');
$('.tabContented').hide();
$('.tabContented:first').show();

// Click function
$('#tabs-nav .tab_head').click(function(){
  $('#tabs-nav .tab_head').removeClass('tab_active');
  $(this).addClass('tab_active');
  $('.tabContented').hide();
 
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();

   if(!$("#ProductRecommendations .Carousel").hasClass('flickity-enabled')){
   $("#ProductRecommendations .Carousel").flickity({
      wrapAround: false,
      pageDots: true,
      contain: true,
      cellAlign: 'center',
      watchCSS: true,
      initialIndex: 0,
      prevNextButtons: true,
     freeScroll: true,
      arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
  
  });
}
  return false;
 
});
  
});
// image stack on load end

// add product with size swatches js
function onQuickBuyButtonClicked(id, pro_id) {
    const CartCount = document.getElementsByClassName('Header__CartCount')[0];

    $(".loader_" + id).addClass("add-success--adding");
    const product = {
        id: id,
        quantity: 1
    };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(product),
        dataType: 'json',
        headers: {
            'Content-Type': 'application/json'
        },
        success: function(cart) {
            setTimeout(function() {
               $(".loader_" + id).removeClass("add-success--adding");
                $(".loader_" + id).addClass("add-success--added");
              cartRecommended(pro_id);
            }, 500);

            setTimeout(function() {
                document.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        variant: cart,
                        quantity: 1
                    }
                }));
              
              
            }, 1200);

            setTimeout(function() {
                $(".loader_" + id).removeClass("add-success--adding").removeClass("add-success--added");
              
            }, 1600);
          setTimeout(function() {
          $('#backdrop').addClass('backdrop_active');
          }, 2000);
        },
        error: function(errorThrown) {
            $(".loader_" + id).removeClass("add-success--adding");

            var r = jQuery.parseJSON(errorThrown.responseText);
            $(".error_" + pro_id).html("Error: " + r.description).show();
            setTimeout(function() {
                $(".error_" + pro_id).html("").hide(100);
            }, 3000);
        }
    });
return false;
}
// end add size swatches js

// product color swatches js add
// $('.product_color_url').on('mouseenter', function() {
//   var dataColorname = $(this).attr('data-name');
//   $('.product_color_url').removeClass('color_product_active');
//   $(this).addClass('color_product_active');
//   $(this).removeClass('color_product');
//   $('.product_color_url').not('.color_product_active').addClass('color_product');
//   $('.product_color_swatches span').html(dataColorname);
// });
// $('.product_color_url').on('mouseleave', function() {
//   $('.product_color_url').removeClass('color_product_active');
//   $('.product_color_url:first-child').addClass('color_product_active');
//   $('.product_color_url:first-child').removeClass('color_product');
//   var dataColorname = $('.product_color_url:first-child').attr('data-name'); 
//   $('.product_color_swatches span').html(dataColorname);
// });
// product color swatches js end 

// product filter acc js start
$(document).on('click', '.Styles__Click .Styles__Trigger', function() {
    if ($(this).parents('.Styles__Click').hasClass("active")) {
      $(this).parents('.Styles__Click').removeClass("active").find(".Styles__Drawer").slideUp();
    } else {
      $(".Styles__Click.active .Styles__Drawer").slideUp();
      $(".Styles__Click.active").removeClass("active");
      $(this).parents('.Styles__Click').addClass("active").find(".Styles__Drawer").slideDown();
    }
    return false;
  });
// product filter acc js end



// load more js start collection page
$(document).on('click', '.js-paginationLoad-more', function(){
 var $this =$(this),
 totalPages = parseInt($('[data-all-pages]').val()),
 currentPage = parseInt($('[data-this-page]').val()),
 datacollurl = $('[data-coll-url]').val();
 $this.attr('disabled', true);
 $this.find('[load-more-text]').addClass('hide');
 $this.find('[loader]').removeClass('hide');
 var nextUrl = $('[data-next-link]').val();
 var current_page_new = currentPage + 1;
 var next_coll = currentPage + 2;
 //alert(current_page_new)
 //return false;
 $.ajax({
 url: nextUrl,
 type: 'GET',
 dataType: 'html',
 success: function(responseHTML){
   $('[data-next-link]').val(datacollurl + "?page="+next_coll);
   $('[data-this-page]').val(current_page_new);
   $('.ProductList--grid').append($(responseHTML).find('.ProductList--grid').html());
   $('.ProductItem').css({ "visibility": "inherit", "opacity": 1, "transform": "matrix(1, 0, 0, 1, 0, 0)" });
   $('.ViewWrap_btn').html($(responseHTML).find('.ViewWrap_btn').html());
   $('.paginations').html($(responseHTML).find('.paginations').html());
 }, 
 complete: function() {
   if(current_page_new < totalPages) {
    $this.attr('disabled', false);
    $this.find('[load-more-text]').removeClass('hide');
    $this.find('[loader]').addClass('hide');
   } 
   if(current_page_new >= totalPages) {
    $this.parents('.load-more_wrap').hide(); 
    $this.find('[loader]').addClass('hide');
   } 
 }
 })
});
function collectionAjax(currentUrl,currentNextPage,currentlastUrl,currentPage,totalPages,datacollurl){
  $.ajax({
  url: currentUrl ,
  type: 'GET',
  dataType: 'html',
  success: function(responseHTML){
    $('.ProductList--grid').append($(responseHTML).find('.ProductList--grid').html());
    $('.ProductItem').css({ "visibility": "inherit", "opacity": 1, "transform": "matrix(1, 0, 0, 1, 0, 0)" });
    $('.ViewWrap_btn').html($(responseHTML).find('.ViewWrap_btn').html());
    $('.paginations').html($(responseHTML).find('.paginations').html());
   currentPage = currentPage + 1;
     if(currentPage <= totalPages){
       console.log(currentPage);
     var currentUrl =  currentNextPage + "page=" + currentPage + "&" +currentlastUrl;
       console.log(currentUrl);
       collectionAjax(currentUrl,currentNextPage,currentlastUrl,currentPage,totalPages,datacollurl);
     } 
    if(currentPage == totalPages){
      $('#Viewed_details').hide();
     $('.ViewWrap_btn').show();
    }
    }
  });
}
  $(document).on('click', '.viewAll_btn', function(){
    var $this =$(this),
    nextPage = $('[data-next-link]').val(),
    totalPages = parseInt($('[data-all-pages]').val()),
    currentPage = parseInt($('[data-this-page]').val()),
    datacollurl = $('[data-coll-url]').val();
    $('.paginations').hide();
    $('.ViewWrap_btn').hide();
    var plusPage = currentPage + 1;

    var currentNextPage =  nextPage.split('page=')[0];

    var currentlastUrl =  nextPage.split('page=')[1].split('&')[1];

    var currentUrl =  currentNextPage + "page=" + plusPage + "&" +currentlastUrl;

    $('#Viewed_details').show();
   collectionAjax(currentUrl,currentNextPage,currentlastUrl,plusPage,totalPages,datacollurl);

  });
// load more js end collection page

// add to cart on mobile
$(document).on('click', '.QuickAddButton',function(){
    var variantpopupHtml = $(this).parents('.ProductItem').find('#quick_mobile_modalWrapper').html();
  $('html').addClass('quick_no-scroll');
    $('#mobile-product-quick-add-modal').html(variantpopupHtml);
});
$(document).on('click', '.quick_mobile_close_btn', function(){
  
  if($(this).hasClass('QuickitemAddedtoCart')){
    $('#mobile-product-quick-add-modal').html('');
    $('.Icon-Wrapper.sidebar-cart_icon').trigger('click');
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
        detail: {
          variant: "",
          quantity: 0
        }
      }));
   // $('.PageOverlay').removeClass('is-visible');
    $('#sidebar-menu').attr('aria-hidden', true); 
  }else{
    $('#mobile-product-quick-add-modal').html('');
    
  }
   $('html').removeClass('quick_no-scroll'); 
});

function onQuickBuymobileButtonClicked(evt, id, pro_id) {
    const CartCount = document.getElementsByClassName('Header__CartCount')[0];
$(evt).parents('.quick_mobile_ModalStyles__Size').addClass('quick_mobile_Sizeli_active');
  console.log(id);
    $(evt).addClass('quick_mobile_Modal__AddingButton').html('Adding <?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="12" r="30" stroke-dasharray="141.37166941154067 49.12388980384689"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.78125s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle>');
    const product = {
        id: id,
        quantity: 1
    };
    console.log(product);
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(product),
        dataType: 'json',
        headers: {
            'Content-Type': 'application/json'
        },
        success: function(cart) {
            setTimeout(function() {
              $(evt).parents('#modalWrapper').find('.quick_mobile_close_btn').addClass('QuickitemAddedtoCart');
             $(evt).addClass('quick_mobile_Modal__AddingButton').html('Added <?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" width="24px" height="24px"><g id="surface80122118"><path style="fill-rule:nonzero;fill:rgb(1.176471%,49.411765%,0%);fill-opacity:1;stroke-width:20;stroke-linecap:butt;stroke-linejoin:round;stroke:rgb(1.176471%,49.411765%,0%);stroke-opacity:1;stroke-miterlimit:10;" d="M 96 206.916667 L 35.208333 146.125 L 50.125 131.208333 L 96 177.083333 L 216.541667 56.541667 L 231.458333 71.458333 Z M 96 206.916667 " transform="matrix(0.09375,0,0,0.09375,0,0)"/><path style=" stroke:none;fill-rule:nonzero;fill:rgb(10.980392%,49.411765%,1.568628%);fill-opacity:1;" d="M 9 19.398438 L 3.300781 13.699219 L 4.699219 12.300781 L 9 16.601562 L 20.300781 5.300781 L 21.699219 6.699219 Z M 9 19.398438 "/></g></svg>'); 
            }, 500);

            setTimeout(function() {
                $(evt).removeClass('quick_mobile_Modal__AddingButton').html('Add to cart <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="005e1e8d-518a-40ef-b78f-7c1e79a16efd"><title id="005e1e8d-518a-40ef-b78f-7c1e79a16efd">Add</title><path d="m13.2 6h-2.4v4.8h-4.8v2.4h4.8v4.8h2.4v-4.8h4.8v-2.4h-4.8zm-1.2-6c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12zm0 21.6c-5.292 0-9.6-4.308-9.6-9.6s4.308-9.6 9.6-9.6 9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6z"></path></svg>');
            $(evt).parents('.quick_mobile_ModalStyles__Size').removeClass('quick_mobile_Sizeli_active');
            }, 1600);
         
        },
        error: function(errorThrown) {
          $(evt).parents('.quick_mobile_ModalStyles__Size').addClass('quick_mobile_Sizeli_activeed');
            var r = jQuery.parseJSON(errorThrown.responseText);
            $(".error_" + id).html("Error: " + r.description).show();
          $(evt).removeClass('quick_mobile_Modal__AddingButton').html('Add to cart <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="005e1e8d-518a-40ef-b78f-7c1e79a16efd"><title id="005e1e8d-518a-40ef-b78f-7c1e79a16efd">Add</title><path d="m13.2 6h-2.4v4.8h-4.8v2.4h4.8v4.8h2.4v-4.8h4.8v-2.4h-4.8zm-1.2-6c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12zm0 21.6c-5.292 0-9.6-4.308-9.6-9.6s4.308-9.6 9.6-9.6 9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6z"></path></svg>'); 

             setTimeout(function() {
              $(".error_" + id).html("").hide(100);
               $(evt).parents('.quick_mobile_ModalStyles__Size').removeClass('quick_mobile_Sizeli_activeed');
              $(evt).parents('.quick_mobile_ModalStyles__Size').removeClass('quick_mobile_Sizeli_active');
              
           }, 3000);
        }
    });
  
}


// mobile_styckyatcButton js start
$(document).on('click', '#mobile_styckyatcButton',function(){
  if($('.SizeSwatchList .SizeSwatch__Radio:checked').val() == undefined){
     var variantpopupHtml = $(this).parents('.Product[data-section-type="product"]').find('#quick_mobile_modalWrapper').html();
    $('#mobile-product-quick-add-modal').html(variantpopupHtml);
  }else{
   // $(this).html('Adding <?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="12" r="30" stroke-dasharray="141.37166941154067 49.12388980384689"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.78125s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle>');
    
    console.log('checked');
    var variantId = $('[name="id"]').val();
    const CartCount = document.getElementsByClassName('Header__CartCount')[0];
  var _this1 = $(this);
   $(this).find('.mobile_styckyatcOverlay').css('opacity', '1');
    $(this).find('.mobile_styckyatcOverlay .loader_wrap').css('opacity', '1');
    const product = {
        id: variantId,
        quantity: 1
    };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(product),
        dataType: 'json',
        headers: {
            'Content-Type': 'application/json'
        },
        success: function(cart) {

            setTimeout(function() {
                document.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        variant: cart,
                        quantity: 1
                    }
                }));
            }, 1000);

            setTimeout(function() {
              _this1.find('.mobile_styckyatcOverlay').css('opacity', '0');
                _this1.find('.mobile_styckyatcOverlay .loader_wrap').css('opacity', '0');
            }, 1600);
    
        },
        error: function(errorThrown) {
          _this1.find('.mobile_styckyatcOverlay').css('opacity', '0');
          _this1.find('.mobile_styckyatcOverlay .loader_wrap').css('opacity', '0');

            var r = jQuery.parseJSON(errorThrown.responseText);
          console.log(r);
          $('.ProductForm__Variants .no-js.ProductForm__Option').after('<div class="error-msg"><p>'+r.description+'</p></div>');
           // $(".error_" + pro_id).html("Error: " + r.description).show();
            setTimeout(function() {
                $('.ProductForm__Variants .error-msg ').remove();
            }, 3000);
        }
    });
return false;
    
  }
   
});

// mobile_styckyatcButton js end

$(document).on('click', '.change-collections', function(){
$('.change-collections').removeClass('active');
$(this).addClass('active');
var handle = $(this).attr('data-handle');
var url = 'https://winnerforce-lb.com/collections/'+handle;
console.log(url);
 $.ajax({
 url: handle,
 type: 'GET',
 dataType: 'html',
 success: function(responseHTML){
  console.log(responseHTML);
   $('.ProductList--grid').html($(responseHTML).find('.ProductList--grid').html());
   $('#collection_filters_top_bar').html($(responseHTML).find('#collection_filters_top_bar').html());
   $('.ProductItem').css({ "visibility": "inherit", "opacity": 1, "transform": "matrix(1, 0, 0, 1, 0, 0)" });
   $('.ViewWrap_btn').html($(responseHTML).find('.ViewWrap_btn').html());
   $('.paginations').html($(responseHTML).find('.paginations').html());
   window.history.pushState({path:url},'',url);
 }, 
 complete: function() {

 }
 })
});

$(document).on('click', '.Product__SlideshowNav_prev', function(){
  var max = $('.Product__SlideshowNavImages').length;
  $(this).parents('.Product__SlideshowNavs').find('.Product__SlideshowNavScrollera a.thumbnail_active').prev().click();
  var imageIndex = $(this).parents('.Product__SlideshowNavs').find('.Product__SlideshowNavScrollera .Product__SlideshowNavImages').attr('data-media-position');
  var imageActiveIndex = $(this).parents('.Product__SlideshowNavs').find('.Product__SlideshowNavScrollera a.thumbnail_active').attr('data-media-position');
  console.log(imageActiveIndex);
  if(imageActiveIndex == 1){
    $(this).css('opacity', '0');
  }else{
    $('.Product__SlideshowNav_prev').css('opacity', '1');
  }
  if(imageActiveIndex != max ){
    $('.Product__SlideshowNav_next').css('opacity', '1');
  } 
});
$(document).on('click', '.Product__SlideshowNav_next', function(){
  var max = $('.Product__SlideshowNavImages').length;
  $(this).parents('.Product__SlideshowNavs').find('.Product__SlideshowNavScrollera a.thumbnail_active').next().click();
  var imageIndex = $(this).parents('.Product__SlideshowNavs').find('.Product__SlideshowNavScrollera .Product__SlideshowNavImages').attr('data-media-position');
  var imageActiveIndex = $(this).parents('.Product__SlideshowNavs').find('.Product__SlideshowNavScrollera a.thumbnail_active').attr('data-media-position');
  console.log(imageActiveIndex);
  if(imageActiveIndex != 1 ){
    $('.Product__SlideshowNav_prev').css('opacity', '1');
  } 
  if(imageActiveIndex == max){
    $(this).css('opacity', '0');
  }else{
    $('.Product__SlideshowNav_next').css('opacity', '1');
  }
});
// size chart js
$(document).on('click', '.size_chart_button', function(){
   $('#product-size-guide-modal').addClass('size_chartPopup_active');
   $('html').addClass('html_no-scroll');
});
$(document).on('click', '.size-guide_pZOBi', function(){
   $('#product-size-guide-modal').removeClass('size_chartPopup_active'); 
  $('html').removeClass('html_no-scroll');
});
$("#size--chart td").each(function(){
  $(this).attr('data-in',$(this).html());
});
$('#onoffbtn').on('change', function(){
  if($(this).is(':checked')){
    $('.onoffbtn').parents('.size_chart_onoff_btn').addClass('btn_active');
    $('.onoffbtn').addClass('active');
    $("#size--chart td").each(function(){
      $(this).html(Math.floor(parseFloat($(this).attr('data-in')) * 2.54));
    });
    $('.sizestyles__FieldUnit').text('cm');
  }
  else{
    $('.onoffbtn').removeClass('active');
    $('.onoffbtn').parents('.size_chart_onoff_btn').removeClass('btn_active');
    $("#size--chart td").each(function(){
      $(this).html($(this).attr('data-in'));
    });
    $('.sizestyles__FieldUnit').text('in');
  }
$('.sizestyles__input').val('');
});
// $(document).on('click', '.sizestyles__ButtonHolder-btn', function(){
//     $('.calculate-your-sizechart__FieldError').remove();
//     var chestInputValue = $('#chest').val();
//     var waistInputValue = $('#waist').val();
//     if(chestInputValue != '' && waistInputValue != ''){
//         console.log(chestInputValue);
//         console.log(waistInputValue);
//         $('#waist').parents('.size_box').removeClass('size_error');
//         $('#chest').parents('.size_box').removeClass('size_error');
//     }else{
//         console.log(chestInputValue);
//         console.log(waistInputValue);
//         if(chestInputValue != '' && waistInputValue == ''){
//           $('#chest').parents('.size_box').removeClass('size_error');
//             $('#waist').parents('.size_box').addClass('size_error');
//             $('.calculate-your-sizestyle').after('<div class="calculate-your-sizechart__FieldError">Please enter a valid number.</div>');
//         }else if(waistInputValue != '' && chestInputValue == ''){
//           $('#waist').parents('.size_box').removeClass('size_error');
//             $('#chest').parents('.size_box').addClass('size_error');
//             $('.calculate-your-sizestyle').after('<div class="calculate-your-sizechart__FieldError">Please enter a valid number.</div>');
//         }else{
//          $('#chest').parents('.size_box').addClass('size_error');
//           $('#waist').parents('.size_box').addClass('size_error');
//          $('.calculate-your-sizestyle').after('<div class="calculate-your-sizechart__FieldError">Please enter a valid number.</div>');
//         }
        
//     }
    
// });
// complete product js 
$(document).on('click', '.complate_set_product_btn', function(){
  $('.complete_the_set_variants input').prop('checked', false);
   $('body').addClass('bodyModel_popup_active');
    $('#complete-the-set-modal').addClass('complete-the-set-active');
  
 
});
$(document).on('click', '.complete_the_set_close', function(){
  $('.complete_the_set_variants input').prop('checked', false);
    $('#complete-the-set-modal').removeClass('complete-the-set-active');
  $('body').removeClass('bodyModel_popup_active');
});

$(document).on('change', '.complete_the_set_variants .ProductItem__SizeSwatchItem input', function(){
  var btnBothText = $('.complete_the_set_product_AddToBagBtn').attr('data-addboth');
  var btnaddText = $('.complete_the_set_product_AddToBagBtn').attr('data-add');
    if($(this).parents('.complete_the_set_Styles__Modal').find('.complete_the_set_Wrapper_product_one .ProductItem__SizeSwatchItem input').is(":checked") && $(this).parents('.complete_the_set_Styles__Modal').find('.complete_the_set_Wrapper_product_two .ProductItem__SizeSwatchItem input').is(":checked")){
        console.log('if');
        $('.complete_the_set_product_AddToBagBtn').removeAttr('disabled');
        $('.complete_the_set_product_AddToBagBtn').html('<svg class="complete_the_set_product_AddToBag_CartIcon" width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="6ec0b77a-8f00-40fa-b72b-a8b867c34db5"><title id="6ec0b77a-8f00-40fa-b72b-a8b867c34db5">Cart</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M45,14.8732257 L36.081895,14.8732257 L36.081895,11.4774544 C36.081895,5.14878873 31.3357722, 0 25.5019853,0 C19.668463,0 14.9228697,5.14878873 14.9228697,11.4774544 L14.9228697,14.8732257 L6, 14.8732257 L6,50 L45,50 L45,14.8732257 Z M21,12.254649 C21,7.89394064 23.4326972,6 26.4655326, 6 C29.498368,6 32,7.89394064 32,12.254649 L32,16 L21,16 L21,12.254649 Z" fill="#000000"></path></g></svg>' +btnBothText); 
    }else{
      if($(this).parents('.complete_the_set_Styles__Modal').find('.complete_the_set_Wrapper_product_one .ProductItem__SizeSwatchItem input').is(":checked") && $(this).parents('.complete_the_set_Styles__Modal').find('.complete_the_set_Wrapper_product_two .ProductItem__SizeSwatchItem input').not(":checked")){
           console.log('if1');
       $('.complete_the_set_product_AddToBagBtn').removeAttr('disabled');   
      }else if($(this).parents('.complete_the_set_Styles__Modal').find('.complete_the_set_Wrapper_product_two .ProductItem__SizeSwatchItem input').is(":checked") && $(this).parents('.complete_the_set_Styles__Modal').find('.complete_the_set_Wrapper_product_one .ProductItem__SizeSwatchItem input').not(":checked")){
           console.log('if2');
        $('.complete_the_set_product_AddToBagBtn').removeAttr('disabled');   
      }
    }
});

$(document).on('click', '.complete_the_set_product_AddToBagBtn', function(event){
      event.preventDefault();
   var btnBothText = $(this).attr('data-addboth');
  var btnaddText = $(this).attr('data-add');
  $(this).html('<?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="10" r="30" stroke-dasharray="141.37166941154067 49.12388980384689"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.78125s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle>'); 
      jsonObj = [];
      var addmainValue = $('.complete_the_set_Wrapper_product_one .complete_the_set_variants input:checked').val();
   if(addmainValue != undefined){
      item = {}
      item ["id"] = parseInt(addmainValue);
      item ["quantity"] = 1;
      jsonObj.push(item);
   }
   var bundledata = $('.complete_the_set_Wrapper_product_two .complete_the_set_variants input:checked').val();
      if(bundledata != undefined){
         item = {}
        item ["id"] = parseInt(bundledata);
        item ["quantity"] = 1;
        jsonObj.push(item);
       }
    //console.log(jsonObj);
    var products = {items: jsonObj};
  //  console.log(JSON.stringify(products));
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(products),
        dataType: 'json',
        headers: {
            'Content-Type': 'application/json'
        },
        success: function(cart) {
            console.log('added');
         $('#complete-the-set-modal').removeClass('complete-the-set-active');
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
            detail: {
              variant: "",
              quantity: 0
            }
          }));
          $('.complete_the_set_variants input').prop('checked', false);
          $('.complete_the_set_product_AddToBagBtn').prop('disabled', true);
          $('.complete_the_set_product_AddToBagBtn').html('<svg class="complete_the_set_product_AddToBag_CartIcon" width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="6ec0b77a-8f00-40fa-b72b-a8b867c34db5"><title id="6ec0b77a-8f00-40fa-b72b-a8b867c34db5">Cart</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M45,14.8732257 L36.081895,14.8732257 L36.081895,11.4774544 C36.081895,5.14878873 31.3357722, 0 25.5019853,0 C19.668463,0 14.9228697,5.14878873 14.9228697,11.4774544 L14.9228697,14.8732257 L6, 14.8732257 L6,50 L45,50 L45,14.8732257 Z M21,12.254649 C21,7.89394064 23.4326972,6 26.4655326, 6 C29.498368,6 32,7.89394064 32,12.254649 L32,16 L21,16 L21,12.254649 Z" fill="#000000"></path></g></svg>' + btnaddText)
                  
        },
        error: function(errorThrown) {
            var r = jQuery.parseJSON(errorThrown.responseText);
            $(".error").html("Error: " + r.description).show();
              setTimeout(function() {
                 $(".error").html("").hide(100);
                 if($('.complete_the_set_Wrapper_product_one .ProductItem__SizeSwatchItem input').is(":checked") && $('.complete_the_set_Wrapper_product_two .ProductItem__SizeSwatchItem input').is(":checked")){
                    $('.complete_the_set_product_AddToBagBtn').html('<svg class="complete_the_set_product_AddToBag_CartIcon" width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="6ec0b77a-8f00-40fa-b72b-a8b867c34db5"><title id="6ec0b77a-8f00-40fa-b72b-a8b867c34db5">Cart</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M45,14.8732257 L36.081895,14.8732257 L36.081895,11.4774544 C36.081895,5.14878873 31.3357722, 0 25.5019853,0 C19.668463,0 14.9228697,5.14878873 14.9228697,11.4774544 L14.9228697,14.8732257 L6, 14.8732257 L6,50 L45,50 L45,14.8732257 Z M21,12.254649 C21,7.89394064 23.4326972,6 26.4655326, 6 C29.498368,6 32,7.89394064 32,12.254649 L32,16 L21,16 L21,12.254649 Z" fill="#000000"></path></g></svg>' +btnBothText);
                }else{
                  if($('.complete_the_set_Wrapper_product_one .ProductItem__SizeSwatchItem input').is(":checked") && $('.complete_the_set_Wrapper_product_two .ProductItem__SizeSwatchItem input').not(":checked")){
                    $('.complete_the_set_product_AddToBagBtn').html('<svg class="complete_the_set_product_AddToBag_CartIcon" width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="6ec0b77a-8f00-40fa-b72b-a8b867c34db5"><title id="6ec0b77a-8f00-40fa-b72b-a8b867c34db5">Cart</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M45,14.8732257 L36.081895,14.8732257 L36.081895,11.4774544 C36.081895,5.14878873 31.3357722, 0 25.5019853,0 C19.668463,0 14.9228697,5.14878873 14.9228697,11.4774544 L14.9228697,14.8732257 L6, 14.8732257 L6,50 L45,50 L45,14.8732257 Z M21,12.254649 C21,7.89394064 23.4326972,6 26.4655326, 6 C29.498368,6 32,7.89394064 32,12.254649 L32,16 L21,16 L21,12.254649 Z" fill="#000000"></path></g></svg>' + btnaddText)
                  }else if($('.complete_the_set_Wrapper_product_two .ProductItem__SizeSwatchItem input').is(":checked") && $('.complete_the_set_Wrapper_product_one .ProductItem__SizeSwatchItem input').not(":checked")){
                    $('.complete_the_set_product_AddToBagBtn').html('<svg class="complete_the_set_product_AddToBag_CartIcon" width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="6ec0b77a-8f00-40fa-b72b-a8b867c34db5"><title id="6ec0b77a-8f00-40fa-b72b-a8b867c34db5">Cart</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M45,14.8732257 L36.081895,14.8732257 L36.081895,11.4774544 C36.081895,5.14878873 31.3357722, 0 25.5019853,0 C19.668463,0 14.9228697,5.14878873 14.9228697,11.4774544 L14.9228697,14.8732257 L6, 14.8732257 L6,50 L45,50 L45,14.8732257 Z M21,12.254649 C21,7.89394064 23.4326972,6 26.4655326, 6 C29.498368,6 32,7.89394064 32,12.254649 L32,16 L21,16 L21,12.254649 Z" fill="#000000"></path></g></svg>' + btnaddText)
                  
                  }
                }
            }, 3000);
          }
      });
    });
$(document).on('change', '.complete_the_set_Wrapper_product_one .complete_the_set_variants input', function(){
    var getPrice = $(this).attr('data-price');
    if(getPrice != undefined){
        $(this).parents('.complete_the_set_Wrapper_product_one').find('.complete_the_set_product_price .ProductMeta__Price').html(getPrice);
    }
});
$(document).on('change', '.complete_the_set_Wrapper_product_two .complete_the_set_variants input', function(){
    var getPrice = $(this).attr('data-price');
    if(getPrice != undefined){
        $(this).parents('.complete_the_set_Wrapper_product_two').find('.complete_the_set_product_price .ProductMeta__Price ').html(getPrice);
    }
});
// sidebar megamenu js
// $('.Collapsible__TabList .Collapsible__Tab_Button:first-child').addClass('menu_active');
// $('.SidebarMenu_item').hide();
// $('.SidebarMenu_item:first').show();

// Click function
$(document).on('click', '.Collapsible__TabList .Collapsible__Tab_Button', function(){
  $('.Collapsible__TabList .Collapsible__Tab_Button').removeClass('menu_active');
  $(this).addClass('menu_active');
  $('.SidebarMenu_item').hide();
 
  var activeTab = $(this).attr('data-action');
  $('#'+activeTab).show();
});
$(document).on('click',function(e){
  if(!(($(e.target).closest(".size_popup_box").length > 0 ) || ($(e.target).closest(".size_chart_button").length > 0))){
    $("#product-size-guide-modal").removeClass('size_chartPopup_active');
       $('html').removeClass('html_no-scroll');
  }
  if(!(($(e.target).closest(".complete_the_set_gRmCL").length > 0 ) || ($(e.target).closest(".complate_set_product_btn").length > 0))){
 $("#complete-the-set-modal").removeClass('complete-the-set-active');
       $('body').removeClass('bodyModel_popup_active');
  }
});
$('.Styles__Click').mouseleave(function() {
  $(".Styles__Drawer").hide();
  $('.Styles__Click').removeClass('active');
});

// --------------------------------
// account register form validation
//-------------------------------------//

function toggleInputField() {
    const passwordField = document.getElementsByClassName('password-reveal__input')[0];
    const wrapper = document.getElementsByClassName('password-reveal-icon__wrapper')[0];
    const type = passwordField.type;

    if (type === 'password') {
        passwordField.setAttribute('type', 'text');
        wrapper.classList.add('hide-password');
    }

    if (type === 'text') {
        passwordField.setAttribute('type', 'password');
        wrapper.classList.remove('hide-password');
    }
}
function showPasswordListeners() {
    const toggleButton = document.getElementsByClassName('icon-password-reveal')[0];
    const passwordContainer = document.getElementsByClassName('password-reveal')[0];
    const passwordField = document.getElementsByClassName('password-reveal__input')[0];

    if (!toggleButton) {
        return;
    }
    if (!passwordContainer) {
        return;
    }
    if (!passwordField) {
        return;
    }

    toggleButton.addEventListener('click', function() {
        if (passwordField.value !== '') {
            toggleInputField();
            passwordContainer.style.borderColor = '#007DB5';
            if (this !== document.activeElement) {
                passwordField.focus();
            }
        }
    });

    passwordField.addEventListener('focus', function() {
        passwordContainer.style.borderColor = '#007DB5';
    });

    passwordField.addEventListener('blur', function() {
        passwordContainer.style.borderColor = '#eeeeee';
    });
}
//  handleError
function handleError(el, errorText) {
    const input = el;
    const errorId = input.classList.contains('birthday') ? 'for-birthday' : 'for-' + el.id;
    const errorSpan = document.getElementById(errorId);
    const errorMessage = errorText ? errorText : input.dataset.errorMessage;

    errorSpan.style.display = 'inline-block';
    errorSpan.innerHTML = errorMessage;
    input.style.borderColor = '#BF2E35';
}
// clearError
function clearError(el) {
    const input = el;
    const errorId = input.classList.contains('birthday') ? 'for-birthday' : 'for-' + el.id;
    const errorSpan = document.getElementById(errorId);

    errorSpan.style.display = 'inline';
    errorSpan.innerHTML = '';
    input.style.borderColor = '#eeeeee';
}

function emailValidation(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}
function birthdayValidation(id, num) {
    if (id === 'day') {
        return num >= 1 && num <= 31;
    }

    if (id === 'month') {
        return num >= 1 && num <= 12;
    }

    if (id === 'year') {
        const year = new Date().getFullYear();
        return num >= 1900 && num <= year;
    }
}

function dateValidation() {
    const birthdayInputs = document.getElementsByClassName('birthday');
    let validateDate = true;

    for (let i = 0; i < birthdayInputs.length; i += 1) {
        const el = birthdayInputs[i];

        if (el.value === '') {
            validateDate = false;
        }
    }

    if (validateDate) {
        const userYear = birthdayInputs[2].value;
        const userMonth = birthdayInputs[1].value;
        const userDate = birthdayInputs[0].value;
        const userDateString = userYear + '-' + userMonth + '-' + userDate;
        const userMoment = moment(userDateString, 'YYYY-MM-DD');

        if (!userMoment.isValid()) {
            handleError(birthdayInputs[2], birthdayInputs[2].dataset.dateValidation);

            return false;
        }

        if (moment().diff(userMoment, 'years') < 18) {
            handleError(birthdayInputs[2], birthdayInputs[2].dataset.dobValidation);

            return false;
        }

        clearError(birthdayInputs[2]);

        return true;
    }
}

function nameValidation(name) {
    return name.trim().length > 1 && /^([^0-9]*)$/.test(name);
}

function genderValidation(gender) {
    return gender;
}

function minimumCharactersCheck(password) {
    return password.length >= 8;
}

function uppercaseCheck(password) {
    return /.*[A-Z]+.*/.test(password);
}

function lowercaseCheck(password) {
    return /.*[a-z]+.*/.test(password);
}

function specialCharacterCheck(password) {
    return /.*[!@#$%^&*(),.?":{}|<>]+.*/.test(password);
}

function numberCheck(password) {
    return /.*[0-9]+.*/.test(password);
}

function passwordValidation(password) {
    return minimumCharactersCheck(password) &&
        uppercaseCheck(password) &&
        lowercaseCheck(password) &&
        specialCharacterCheck(password) &&
        numberCheck(password);
}

function handlePasswordError(password) {
    const container = document.getElementsByClassName('password-validation')[0];
    container.style.display = 'block';

    const input = document.getElementsByClassName('password-reveal')[0];
    input.style.borderColor = '#BF2E35';

    const errorSpan = document.getElementById('for-password');
    errorSpan.style.display = 'inline-block';

    const characters = document.getElementById('pw_characters');
    const uppercase = document.getElementById('pw_uppercase');
    const lowercase = document.getElementById('pw_lowercase');
    const special = document.getElementById('pw_special');
    const num = document.getElementById('pw_number');

    characters.style.opacity = minimumCharactersCheck(password) ? '1' : '0.3';
    uppercase.style.opacity = uppercaseCheck(password) ? '1' : '0.3';
    lowercase.style.opacity = lowercaseCheck(password) ? '1' : '0.3';
    special.style.opacity = specialCharacterCheck(password) ? '1' : '0.3';
    num.style.opacity = numberCheck(password) ? '1' : '0.3';
    errorSpan.style.color = passwordValidation(password) ? '#9b9b9b' : '#BF2E35';
    if (passwordValidation(password)) {
        input.style.borderColor = '#007DB5';
    }
}

function assignPwKeyUpListener(el) {
    el.addEventListener('keyup', function() {
        handlePasswordError(el.value);
    });
}

function clearPasswordError() {
    const container = document.getElementsByClassName('password-validation')[0];
    container.style.display = 'none';

    const inputContainer = document.getElementsByClassName('password-reveal')[0];
    inputContainer.style.borderColor = '#eeeeee';

    const errorSpan = document.getElementById('for-password');
    errorSpan.style.display = 'inline';
}

function loginPasswordError() {
    const input = document.getElementsByClassName('password-reveal')[0];
    input.style.borderColor = '#BF2E35';
}

// requaired check
function requiredCheck() {
    const elements = Array.from(document.querySelectorAll('.centered-form input')).concat(
        Array.from(document.querySelectorAll('.centered-form select'))
    );
    let complete = true;
    for (let i = 0; i < elements.length; i += 1) {
        const el = elements[i];
        if (!el.value) {
            complete = false;
        }
    }

    if (complete) {
        const alert = document.getElementsByClassName('alert')[0];
        alert.style.display = 'none';
    }
}


// validate form

function validator(val, el) {
    requiredCheck();
    switch (el.id) {
        case 'email':
            if (!emailValidation(val)) {
                handleError(el);
                break;
            }
            clearError(el);
            break;
        case 'day':
        case 'month':
        case 'year':
            if (!birthdayValidation(el.id, val)) {
                handleError(el);
                break;
            }
            clearError(el);
            dateValidation();
            break;
        case 'firstname':
        case 'lastname':
            if (!nameValidation(val)) {
                handleError(el);
                break;
            }
            clearError(el);
            break;
        case 'gender':
            if (!genderValidation(val)) {
                handleError(el);
                break;
            }
            clearError(el);
            break;
        case 'password':
            if (!passwordValidation(val)) {
                handlePasswordError(val);
                assignPwKeyUpListener(el);
                break;
            }
            clearPasswordError();
        default:
            break;
    }
}

// click function
function createAccountListeners() {
    const toValidate = document.getElementsByClassName('toValidate');

    Array.prototype.forEach.call(toValidate, function(el) {
        let eventType;
        if (el.id === 'gender' || el.id === 'day' || el.id === 'month' || el.id === 'year') {
            eventType = 'change';
        } else {
            eventType = 'blur';
        }

        el.addEventListener(eventType, function(e) {
            validator(e.target.value, el);
        });
    });
}
// document load
document.addEventListener('DOMContentLoaded', function() {
    showPasswordListeners();
    createAccountListeners();
});

// load more js start blog page
$(document).on('click', '.js-blogLoad-more', function(){
   var $this =$(this),
   totalPages = parseInt($('[data-all-pages]').val()),
   currentPage = parseInt($('[data-this-page]').val()),
   datablogurl = $('[data-blog-url]').val();
   $this.attr('disabled', true);
   $this.find('[load-more-text]').addClass('hide');
   $this.find('[loader]').removeClass('hide');
   var nextUrl = $('[data-next-link]').val();
   var current_page_new = currentPage + 1;
   var next_coll = currentPage + 2;
   //alert(current_page_new)
   //return false;
   $.ajax({
   url: nextUrl,
   type: 'GET',
   dataType: 'html',
   success: function(responseHTML){
     $('[data-next-link]').val(datablogurl + "?page="+next_coll);
     $('[data-this-page]').val(current_page_new);
     $('.ArticleList').append($(responseHTML).find('.ArticleList').html());
     $('.ArticleItem').css({ "visibility": "inherit", "opacity": 1, "transform": "matrix(1, 0, 0, 1, 0, 0)" });
     // $('.ViewWrap_btn').html($(responseHTML).find('.ViewWrap_btn').html());
     $('.blog_paginations').html($(responseHTML).find('.blog_paginations').html());
   }, 
   complete: function() {
     if(current_page_new < totalPages) {
      $this.attr('disabled', false);
      $this.find('[load-more-text]').removeClass('hide');
      $this.find('[loader]').addClass('hide');
     } 
     if(current_page_new >= totalPages) {
      $this.parents('.load-more_wrap').hide(); 
      $this.find('[loader]').addClass('hide');
     } 
   }
   });
});
// load more js start predictive search page
$(document).on('click', '.js-searchLoad-more', function(){
 var $this =$(this),
 totalPages = parseInt($('[data-all-pages]').val()),
 currentPage = parseInt($('[data-this-page]').val()),
 datacollurl = $('[data-coll-url]').val();
 $this.attr('disabled', true);
 $this.find('[load-more-text]').addClass('hide');
 $this.find('[loader]').removeClass('hide');
 var nextUrl = $('[data-next-link]').val();
 var current_page_new = currentPage + 1;
 var next_coll = currentPage + 2;
 //alert(current_page_new)
 //return false;
 $.ajax({
 url: nextUrl,
 type: 'GET',
 dataType: 'html',
 success: function(responseHTML){
   $('[data-next-link]').val(datacollurl + "?page="+next_coll);
   $('[data-this-page]').val(current_page_new);
   $('.Segment__Content .Grid').append($(responseHTML).find('.Segment__Content .Grid').html());
   // $('.ProductItem').css({ "visibility": "inherit", "opacity": 1, "transform": "matrix(1, 0, 0, 1, 0, 0)" });
   // $('.ViewWrap_btn').html($(responseHTML).find('.ViewWrap_btn').html());
   $('.paginations').html($(responseHTML).find('.paginations').html());
 }, 
 complete: function() {
   if(current_page_new < totalPages) {
    $this.attr('disabled', false);
    $this.find('[load-more-text]').removeClass('hide');
    $this.find('[loader]').addClass('hide');
   } 
   if(current_page_new >= totalPages) {
    $this.parents('.load-more_wrap').hide(); 
    $this.find('[loader]').addClass('hide');
   } 
 }
 })
});
$(document).on('click', '.Styles__ClearSearch', function(){
    $('.Search__Input').val('');
    $('.Search__Results').html('');
     $('.Search__Results').attr('aria-hidden', true);
    $('.Styles__ClearSearch').hide();
});

$(document).on('click', '#backdrop', function(event){
 var targetElement = event.target;
 if (targetElement.id.includes("backdrop") || targetElement.id.includes("cart-product-recommendations")) {
  $(".PageOverlay").trigger("click");
}
});




//  custom kit pages code.
$(document).on('click', '.add_to_cart_button.available', function(event){
  event.preventDefault();
  jsonObj = [];
  $(this).parents('.Image_with_product_right').find('input:checked').each(function() {
    var id = $(this).val();
    item = {}
    item ["id"] = parseInt(id);
    item ["quantity"] = 1;
    jsonObj.push(item);
  });
var products = {items: jsonObj};
 console.log(products);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(products),
    dataType: 'json',
    headers: {
        'Content-Type': 'application/json'
    },
    success: function(cart) {
    console.log('added');
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
        detail: {
          variant: "",
          quantity: 0
        }
      }));   
    },
    error: function(errorThrown) {
        var r = jQuery.parseJSON(errorThrown.responseText);
        $(".error").html("Error: " + r.description).show();
          setTimeout(function() {
             $(".error").html("").hide(100);
        }, 3000);
      }
  });
});

$(document).on('click', '.product_color_group .color_product_active', function(event){
  event.preventDefault();
});

$(document).on('click', '.product_color_group .product_color_url:not(.color_product_active)', function(event){
  event.preventDefault();
  const link  = $(this).attr('href');
  $('.product_color_url').removeClass('color_product_active');
  $(this).addClass('color_product_active');
  var dataColorname = $(this).attr('data-name');
  $('.product_color_swatches span').html(dataColorname);
  console.log(link);
  fetch(link)
  .then(function(response) {
    return response.text()
  })
  .then(function(html) {
    var parser = new DOMParser(); 
    var html = parser.parseFromString(html, "text/html");
    $('.breadcrumbs').html($(html).find('.breadcrumbs').html());
    $('.Product__Gallery').html($(html).find('.Product__Gallery').html());
    $('.ProductMeta__SkuNumber').html($(html).find('.ProductMeta__SkuNumber').html());
    $('.ProductMeta__Title').html($(html).find('.ProductMeta__Title').html());
    $('.ProductMeta__PriceList').html($(html).find('.ProductMeta__PriceList').html());
    $('.ProductForm__Variants').html($(html).find('.ProductForm__Variants').html());
    var addToCartButton = document.querySelector('.ProductForm__AddToCart');
    addToCartButton.classList.remove('Button--primary');
     addToCartButton.classList.add('Button--secondary');  


     var productJson = $(html).find('[data-product-json]').html();
     console.log(productJson);
     
     $('[data-product-json]').html(productJson);


setTimeout(function(){
  $('.pdpZoom__ActiveImageContainer').html($(html).find('.pdpZoom__ActiveImageContainer').html());
    var $carousel = $('.carousel').flickity({
      "prevNextButtons": true,
      "adaptiveHeight": true
    });
    
    var $carouselNav = $('.carousel-nav');
    var $carouselNavCells = $carouselNav.find('.carousel-cell');
    
    $carouselNav.on('click', '.carousel-cell', function (event) {
      var index = $(event.currentTarget).index();
      $carousel.flickity('select', index);
    });
    
    var flkty = $carousel.data('flickity');
    var navTop = $carouselNav.position().top;
    var navCellHeight = $carouselNavCells.height();
    var navHeight = $carouselNav.height();
    
    $carousel.on('select.flickity', function () {
      // set selected nav cell
      $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
      var $selected = $carouselNavCells.eq(flkty.selectedIndex).
      addClass('is-nav-selected');
      // scroll nav
      var scrollY = $selected.position().top +
      $carouselNav.scrollTop() - (navHeight + navCellHeight) / 2;
      $carouselNav.animate({
        scrollTop: scrollY 
      });
    });
  },1000);
  })
  .catch(function(err) {  
    console.log('Failed to fetch page: ', err);  
  });

});
